// Power Curve and Speed Curve
export function generateKDiagramResultSplineSeries(data, name, pointFormat = null) {
  return {
    name: name,
    color: "var(--kdiagram-power-interpolation-line-color)",
    type: "spline",
    zIndex: 100,
    data: data,
    marker: {
      enabled: true,
      radius: 1.5,
      symbol: "circle",

      fillColor: "#b5b5b5",
      lineWidth: 1,
      lineColor: "#8a8a8a",

      states: {
        inactive: {
          opacity: 0.2
        },
        hover: {
          enabled: true,
          radius: 5,
          fillColor: "#9e9e9e",
          lineColor: "#6f6f6f",
        },
      },
    },
    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
    tooltip: {
      pointFormat: pointFormat
    }
  };
}
